/**
 * Catch-all 404 for unknown routes. Marked noindex so junk URLs do not rank.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Seo from '../components/Seo';
import './NotFound.css';

const NotFound = () => {
  const { t, localePath } = useLanguage();

  return (
    <div className="not-found">
      <Seo
        title={t('notFound.title')}
        description={t('notFound.lead')}
        path="/404"
        noindex
      />
      <div className="container not-found__inner">
        <p className="not-found__code">404</p>
        <h1>{t('notFound.title')}</h1>
        <p className="not-found__lead">{t('notFound.lead')}</p>
        <div className="not-found__actions">
          <Link to={localePath('/')} className="not-found__btn">
            {t('notFound.home')}
          </Link>
          <Link to={localePath('/blog')} className="not-found__link">
            {t('notFound.blog')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
